import React from 'react'

const EmailSentIcon = ({ color = '#ebebeb' }) => {
  const imgStyle = {
    fill: 'none',
    stroke: color,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    strokeMiterlimit: 10,
    strokeWidth: '2px',
  }
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30.376" height={30} viewBox="0 0 30.376 30">
      <g
        id="email-envelope-message-timer-schedule-time-svgrepo-com"
        transform="translate(-1.624 -2)"
      >
        <path id="Path_912" data-name="Path 912" style={imgStyle} d="M3,8l13,8L29,8" />
        <circle
          id="Ellipse_79"
          data-name="Ellipse 79"
          style={imgStyle}
          cx={7}
          cy={7}
          r={7}
          transform="translate(17 17)"
        />
        <path
          id="Path_913"
          data-name="Path 913"
          style={imgStyle}
          d="M17.1,25H7a4.012,4.012,0,0,1-4-4V7A4.012,4.012,0,0,1,7,3H25a4.012,4.012,0,0,1,4,4V19.1"
        />
        <path id="Path_914" data-name="Path 914" style={imgStyle} d="M24,20v4l3-2" />
      </g>
    </svg>
  )
}

export default EmailSentIcon
